import*as _0x178b57 from'react';import _0x4755c5 from'./FormControlContext';export default function useFormControl(){return _0x178b57['useContext'](_0x4755c5);}